export default __webpack_public_path__ + "static/media/forestly-expl-base_EN.c3f1c4eb.png";